<template>
    <section class="footer">
        <div class="box-container container">
            <div class="box">
                <i class="fas fa-phone"></i>
                <h3>Telefoonnummer</h3>
                <p><a href="tel:+31735515644" class="contact-link">073-5515644</a></p>
            </div>

            <div class="box">
                <i class="fas fa-map-marker-alt"></i>
                <h3>Adres</h3>
                <p>Schijndelseweg 13A<br>5271 BK Sint-Michielsgestel</p>
            </div>

            <div class="box opening-hours-footer">
                <i class="fas fa-clock"></i>
                <h3>Openingstijden</h3>
                <p>ma - do 08:15 tot 17:00<br> <span class="second-row-opening-hours">vr 08:00 - 12:30 </span></p>
            </div>

            <div class="box phone-hours-footer">
                <i class="fas fa-phone-alt"></i>
                <h3>Telefonisch bereikbaar</h3>
                <div class="phone-schedule">
                    <p class="phone-days"><strong>Ma - Do:</strong> 08:15 - 17:00</p>
                    <p class="phone-days"><strong>Vrijdag:</strong> 08:00 - 12:30</p>
                    <p class="phone-breaks"><em>Tijdens pauzes zijn wij niet bereikbaar.</em></p>
                </div>
            </div>

            <div class="box">
                <i class="fas fa-envelope"></i>
                <h3>Email</h3>
                <p><a href="mailto:info@tandzorggestel.nl" class="contact-link">info@tandzorggestel.nl</a></p>
            </div>
        </div>
        
        <!-- Navigatie sectie -->
        <div class="footer-navigation">
            <div class="container">
                <div class="nav-columns">
                    <div class="nav-column">
                        <h4>Behandelingen</h4>
                        <ul>
                        <li><router-link to="/diensten#alignment-specialist">Preventieve Tandheelkunde</router-link></li>
                        <li><router-link to="/diensten#cosmetic-dentistry">Restauratieve Tandheelkunde</router-link></li>
                        <li><router-link to="/diensten#oral-hygiene-experts">Cosmetische Tandheelkunde</router-link></li>
                        <li><router-link to="/diensten#root-canal-specialist">Parodontale Zorg</router-link></li>
                            <li><router-link to="/diensten#ems-airflow-technologie">EMS Airflow Technologie</router-link></li>
                            <li><router-link to="/diensten#digitale-scanner">Digitale Scanner</router-link></li>
                        <li><router-link to="/diensten#live-dental-advisory">Aligners</router-link></li>
                        <li><router-link to="/diensten#cavity-inspection">Endodontologie</router-link></li>
                        </ul>
                    </div>
                    <div class="nav-column">
                        <h4>Praktijk</h4>
                        <ul>
                            <li><router-link to="/over-ons">Over Ons</router-link></li>
                            <li><router-link to="/het-team">Het Team</router-link></li>
                            <li><router-link to="/de-lieve-tandarts">De Lieve Tandarts</router-link></li>
                            <li><router-link to="/info">Praktijk Informatie</router-link></li>
                        </ul>
                    </div>
                    <div class="nav-column">
                        <h4>Service</h4>
                        <ul>
                            <li><router-link to="/afspraak-maken">Afspraak Maken</router-link></li>
                            <li><router-link to="/inschrijven">Inschrijven</router-link></li>
                            <li><router-link to="/contact">Contact</router-link></li>
                            <li><router-link to="/spoed">Spoedgevallen</router-link></li>
                        </ul>
                    </div>
                    <div class="nav-column">
                        <h4>Regio</h4>
                        <ul>
                            <li><router-link to="/tandarts-den-bosch">Tandarts Den Bosch</router-link></li>
                            <li><router-link to="/tandarts-vught">Tandarts Vught</router-link></li>
                            <li><router-link to="/tandarts-boxtel">Tandarts Boxtel</router-link></li>
                            <li><router-link to="/tandarts-haaren">Tandarts Haaren</router-link></li>
                          <li><router-link to="/tandarts-berlicum">Tandarts Berlicum</router-link></li>
                          <li><router-link to="/tandarts-schijndel">Tandarts Schijndel</router-link></li>
                          <li><router-link to="/tandarts-liempde">Tandarts Liempde</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Lidmaatschappen sectie -->
        <div class="partnerships-section">
            <div class="container">
                <h3>Lidmaatschappen</h3>
                <div class="logo-container">
                    <div class="partnership-item">
                        <img src="../assets/images/lieve-tandarts-liggend.png" alt="Lieve Tandarts" class="partnership-logo">
                        <p>Lid van De Lieve Tandarts</p>
                    </div>
                    <div class="partnership-item">
                        <img src="../assets/images/KRT.png" alt="KRT - Kwaliteitsregister voor Tandtechnici" class="partnership-logo">
                        <p>Lid van KRT</p>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="credit">
           &copy; {{ new Date().getFullYear() }} Tandzorg Gestel - 

           <router-link to="/privacy-policy" class="privacy-policy">Privacy Policy</router-link>

        </div>
     </section>
</template>

<script>
export default {
  name: "Footer",
}
</script>

<style scoped>
section {
  padding: 0;
}
.footer {
  background-color: var(--light-bg);
  padding-top: 4rem;
}
.footer .box-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 5 gelijke kolommen */
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
.footer .box-container .box {
  text-align: center;
}
.footer .box-container .box i {
  height: 5rem;
  width: 5rem;
  border-radius: 50%;
  line-height: 5rem;
  font-size: 2rem;
  background-color: var(--blue);
  color: var(--white);
}
.footer .box-container .box h3 {
  font-size: 2rem;
  margin: 2rem 0;
  color: var(--black);
}
.footer .box-container .box p {
  font-size: 1.5rem;
  color: var(--light-color);
  text-transform: none;
}

/* Telefonische bereikbaarheid styling */
.phone-hours-footer .phone-schedule {
  text-align: center;
}

.phone-hours-footer .phone-days {
  font-size: 1.6rem;
  color: var(--black);
  margin-bottom: 0.8rem;
  font-weight: 500;
}

.phone-hours-footer .phone-breaks {
  font-size: 1.3rem;
  color: var(--light-color);
  margin: 0.5rem 0 0.3rem 0;
  font-style: italic;
}

.phone-hours-footer .break-times {
  font-size: 1.4rem;
  color: var(--light-color);
  line-height: 1.4;
  margin-bottom: 0.8rem;
}

.phone-hours-footer .friday-note {
  font-size: 1.5rem;
  margin-top: 0.8rem;
  margin-bottom: 0;
}

.phone-hours-footer .not-available {
  color: #e74c3c;
  font-weight: 500;
}

/* Responsive footer grid */
@media (max-width: 1200px) {
  .footer .box-container {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .footer .box-container {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}
.footer .credit {
  text-align: center;
  border-top: var(--border);
  padding-top: 2rem;
  padding-bottom: 2rem;
  margin-top: 2rem;
  font-size: 14px;
  color: var(--light-color);
  /* padding-bottom: 2rem; */
}

/* Partnerships sectie styling */
.partnerships-section {
  background-color: var(--light-bg);
  padding: 3rem 0;
  border-top: var(--border);
  margin-top: 2rem;
}

.partnerships-section h3 {
  text-align: center;
  font-size: 2rem;
  color: var(--black);
  margin-bottom: 2rem;
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.partnership-item {
  text-align: center;
  max-width: 250px; /* groter gemaakt voor grotere logo's */
}

.partnership-logo {
  width: 180px; /* veel groter gemaakt voor betere leesbaarheid */
  height: 90px; /* verhoogd om proportie te behouden */
  object-fit: contain;
  margin-bottom: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.partnership-item p {
  font-size: 1.6rem; /* groter gemaakt voor betere leesbaarheid */
  color: var(--light-color);
  margin: 0;
  font-weight: 500; /* iets zwaarder voor betere contrast */
}
.footer .credit span {
  color: var(--blue);
}
.privacy-policy {
  color: #3a3a3a;
}

/* Footer navigation styling */
.footer-navigation {
  background-color: var(--white);
  padding: 3rem 0;
  margin: 2rem 0;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.footer-navigation .nav-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 3rem;
  max-width: 1400px;
  margin: 0 auto;
}

.footer-navigation .nav-column h4 {
  font-size: 1.8rem;
  color: var(--blue);
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.footer-navigation .nav-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-navigation .nav-column li {
  margin-bottom: 0.8rem;
}

.footer-navigation .nav-column a {
  color: var(--light-color);
  text-decoration: none;
  font-size: 1.5rem;
  transition: color 0.3s ease;
}

.footer-navigation .nav-column a:hover {
  color: var(--blue);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .footer-navigation .nav-columns {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
}
</style>